import { Input, Output, EventEmitter, Optional, Host } from '@angular/core';
import { C4Form } from './c4-form';

export interface C4InputConfig {
  layout?: string;
  labelColumns?: number;
  inputColumns?: number;
}

export const SENSIBLE_DEFAULT_CONFIG: C4InputConfig = {
  layout: 'horizontal',
  labelColumns: 3
}

export interface C4Option {
  target?: string, // For internal testing only
  type: string;
  name: string;
  value?: string | number | boolean;
  valueType?: string;
  low?: number;
  high?: number;
  values?: any[];
  valueSrc?: { method: string, path: string };
  valueField?: string;
  valueDisplay?: string;
}

export interface C4InputInterface {
  config: C4InputConfig;
  name: string;
  tagId: string;
  value: string | number | boolean;
  valueChange: EventEmitter<string | number | boolean>;

  prefix?: string;
  suffix?: string;
  precision?: number;
  increment?: number;
  stepCount?: number;
  min?: number;
  max?: number;
  options?: C4Option[];
  optionsUrl?: string;
  optionKey?: string;
  optionDisplay?: string;

  init(model: C4Option, config: C4InputConfig): void;
}

export abstract class C4Input implements C4InputInterface {
  config: C4InputConfig;
  name: string;
  tagId: string;
  value: string | number | boolean;
  valueChange: EventEmitter<string | number | boolean>;

  protected form: C4Form;

  constructor( @Optional() @Host() form: C4Form) {
    this.form = form;
  }

  ngOnInit() {
    this.config = this.config || (this.form || { config: undefined }).config || SENSIBLE_DEFAULT_CONFIG;
  }

  init(model: C4Option, config: C4InputConfig) {
    this.config = config || this.config || SENSIBLE_DEFAULT_CONFIG;

    this.name = model.name;
    this.value = model.value;

    this.tagId = model.name + '-' + model.type + '-' + model.valueType;
  }
}



// WEBPACK FOOTER //
// ./~/@c4/ui/src/app/directives/input/c4-input.ts